import { render, staticRenderFns } from "./BankContactEmail.vue?vue&type=template&id=af24a48a"
import script from "./BankContactEmail.vue?vue&type=script&lang=js"
export * from "./BankContactEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports